<template>
  <v-list-item-group mandatory active-class="active-topic" class="mt-4 mx-3" :value="selectedTopicId">
    <p class="text-h6">{{ $t('wb-config.basisdaten.title') }}</p>
    <list-item-with-checkbox
      @onSelected="(event, topic) => $emit('onSelectedTopic', event, topic)"
      itemId="basedata"
      value="basedata"
      :itemTitle="$t('bf.informationData')"
      :actionCompleted="questionnaireData.baseData.completed"
    />
    <v-list v-for="section in questionnaire.sections" :key="`section-id-${section.id}`" class="sections-dark-mode">
      <p class="text-h6">{{ section.title }}</p>

        <list-item-with-checkbox
        @onSelected="(event, topic) => $emit('onSelectedTopic', event, topic)"
        v-for="topic in section.topics"
        :key="`topic-id-${topic.id}`"
        :itemId="`topic-id-${topic.id}`"
        :value="topic.id"
        :itemTitle="topic.title"
        :actionCompleted="questionnaireData.topics[topic.id].completed"
      />

    </v-list>
    <p class="text-h6">{{ $t('bf.conclusion') }}</p>
    <list-item-with-checkbox
      @onSelected="(event, topic) => $emit('onSelectedTopic', event, topic)"
      itemId="note"
      value="note"
      :itemTitle="$t('fahrdienst452.comment')"
      :actionCompleted="!!questionnaireData.note"
    />
    <list-item-with-checkbox
      v-if="questionnaire.isType && questionnaire.isType === evaluationType"
      @onSelected="(event, topic) => $emit('onSelectedTopic', event, topic)"
      itemId="overallGrade"
      value="overallGrade"
      :itemTitle="$t('bf.overallGrade')"
    />
    <list-item-with-checkbox
      v-else
      @onSelected="(event, topic) => $emit('onSelectedTopic', event, topic)"
      itemId="review"
      value="review"
      :itemTitle="$t('bf.review')"
    />
    <list-item-with-checkbox
        @onSelected="(event, topic) => $emit('onSelectedTopic', event, topic)"
        itemId="complete"
        value="complete"
        :itemTitle="$t('begleitfahrt.complete')"
    />
  </v-list-item-group>
</template>

<script>
import common from '../../../mixins/common';
import ListItemWithCheckbox from '../components/ListItemWithCheckbox.vue';

  export default {
    components: { ListItemWithCheckbox },
    name: 'DrawerDesktop',
    mixins: [common],
    props: {
      value: {
        type: Object,
        required: true
      },
      selectedTopicId: {
        type: String,
        default: 'basedata'
      },
      questionnaire: {
        type: Object,
        required: true
      },
      evaluationType: {
        type: String,
        required: true
      },
    },
    computed: {
      questionnaireData() {
        return this.value;
      }
    }
  };
</script>

<style scoped>

  .theme--dark .sections-dark-mode {
    background-color: #191919;
  }

  p.text-h6 {
    font-size: 1.1rem !important;
    margin: 0 0 0.2rem 1rem;
  }
</style>